const normalizarTexto = (texto = '') =>
  String(texto)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const classificarAlerta = (mensagem) => {
  const texto = normalizarTexto(mensagem);

  if (texto.includes('emergencia') || texto.includes('critico')) {
    return { tipo: 'critico', rotulo: 'Crítico' };
  }

  if (
    texto.includes('alerta') ||
    texto.includes('nivel minimo') ||
    texto.includes('nivel maximo') ||
    texto.includes('falha')
  ) {
    return { tipo: 'atencao', rotulo: 'Atenção' };
  }

  return { tipo: 'informativo', rotulo: 'Informativo' };
};

export const limparMensagemAlerta = (mensagem) =>
  String(mensagem || 'Alerta sem descrição')
    .replace(/^alerta\s*:\s*/i, '')
    .replace(/\s+/g, ' ')
    .trim();

export const formatarDataHoraAlerta = (createdAt) => {
  const data = new Date(createdAt);

  if (Number.isNaN(data.getTime())) {
    return { dia: '--/--/----', diaCurto: '--/--', hora: '--:--' };
  }

  return {
    dia: data.toLocaleDateString('pt-BR'),
    diaCurto: data.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }),
    hora: data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }),
  };
};
